module.exports = __webpack_public_path__ + "img/league_inspection.d2088618.svg";